import React from "react"
import { UserRole } from "../../types/user"
import { t } from "../../i18n";

interface Props {
  role: UserRole;
}

const UserTermsLabel = ({ role }: Props): JSX.Element => {
  if (role === "business_borrower") role = "borrower";
  const content = (t(`terms_${role}`)).concat(" ", t("registration.tips.data_processing"));
  return (
    <span dangerouslySetInnerHTML={{ __html: content }}/>
  )
}

export default UserTermsLabel
